import { loadable } from '@fiverr-private/perseus';
import { DROPZONE_CATEGORY } from '../../../../constants';
import DropzoneConfig from '../../../../docs/builderDropzoneComponents/Dropzone.json';

const Dropzone = loadable(() => import(/* webpackChunkName: "Dropzone" */ './dropzone'));
Dropzone.displayName = 'Dropzone';

const DROPZONE_CONFIG = {
    components: [
        {
            element: Dropzone,
            componentConfig: DropzoneConfig,
            manualInputs: [
                {
                    name: 'accept',
                    type: 'json',
                    defaultValue: {
                        'image/*': ['.jpg', '.jpeg', '.png'],
                        'video/*': ['.avi', '.mp4'],
                    },
                    required: false,
                },
            ],
        },
    ],
    category: DROPZONE_CATEGORY,
};

export default DROPZONE_CONFIG;
